import { PositiveColors, TextColors } from '@picsart/design-system/foundation/colors';
import { FontSizes, LineHeights } from '@picsart/design-system/foundation/typography';

import { createUseStyles } from 'react-jss';

import { FontWeights } from '@picsart/design-system/foundation/fonts';
import { CornerRadius } from '@picsart/design-system/foundation/cornerRadius';
import { BreakPointsMedia } from '@picsart/design-system/foundation/responsive';
import { Spacings } from '@picsart/design-system/foundation/spacings';
// import { BreakPoints } from '@picsart/rc/enums';
// import { mediaQuery } from '@picsart/rc/helpers';

const useStyles = createUseStyles<string, { mediaIsLeft?: boolean; titleColor?: string }>(
  {
    root: {
      display: 'flex',
      flexWrap: 'wrap',
      marginBottom: Spacings.s72,

      // [mediaQuery(BreakPoints.Small)]: {
      '@media screen and (max-width: 768px)': {
        marginBottom: Spacings.s24,
      },
    },
    subTitle: {
      width: '100%',
      fontSize: FontSizes.s16,
      fontWeight: FontWeights.semibold,
      lineHeight: LineHeights.l24,
      color: TextColors.tint1,
    },
    title: {
      width: '100%',
      marginBottom: Spacings.s24,
      '& i': {
        color: ({ titleColor }) => titleColor || 'currentColor',
        fontStyle: 'normal',
      },

      // [mediaQuery(BreakPoints.Small)]: {
      '@media screen and (max-width: 766px)': {
        width: '60%',
      },

      // [mediaQuery(OldBreakPoints.small)]: {
      '@media screen and (max-width: 768px)': {
        width: '100%',
      },
    },
    descriptionContainer: {
      width: '30%',
      order: props => (props?.mediaIsLeft ? 2 : 1),
      paddingLeft: props => (props?.mediaIsLeft ? Spacings.s32 : Spacings.s0),
      paddingRight: props => (!props?.mediaIsLeft ? Spacings.s32 : Spacings.s0),
      textAlign: props => (props?.mediaIsLeft ? '-webkit-right' : '-webkit-left'),

      [BreakPointsMedia.XL]: {
        width: '40%',
      },
      [BreakPointsMedia.LG]: {
        width: '40%',
      },
      [BreakPointsMedia.MD]: {
        width: '40%',
      },
      [BreakPointsMedia.SM]: {
        width: '40%',
      },
      [BreakPointsMedia.XS]: {
        width: '40%',
      },
      [BreakPointsMedia.XXS]: {
        width: '40%',
      },

      // [mediaQuery(BreakPoints.Small)]: {
      '@media screen and (max-width: 766px)': {
        '&&': {
          order: 1,
          paddingInline: Spacings.s0,
        },
      },

      // [mediaQuery(OldBreakPoints.small)]: {
      '@media screen and (max-width: 768px)': {
        '&&': {
          width: '100%',
        },
      },

      '& button, & a': {
        marginTop: Spacings.s40,

        // [mediaQuery(480)]: {
        '@media screen and (max-width: 480px)': {
          width: '100%',
        },
      },
    },
    innerContainer: {
      width: 'max-content',
      maxWidth: '100%',
      textAlign: 'left',
    },
    description: {
      display: 'block',
      maxHeight: 410,
      fontSize: FontSizes.s20,
      fontWeight: FontWeights.medium,
      lineHeight: LineHeights.l28,

      // [mediaQuery(BreakPoints.Small)]: {
      '@media screen and (max-width: 766px)': {
        maxWidth: '100%',
      },

      '&&': {
        '&& a': {
          color: PositiveColors.text.default,
          margin: Spacings.s0,
          fontWeight: FontWeights.bold,
        },
      },
    },
    media: {
      width: '70%',
      order: props => (props?.mediaIsLeft ? 1 : 2),

      [BreakPointsMedia.XL]: {
        width: '60%',
      },
      [BreakPointsMedia.MD]: {
        width: '60%',
      },
      [BreakPointsMedia.SM]: {
        width: '60%',
      },
      [BreakPointsMedia.XS]: {
        width: '60%',
      },
      [BreakPointsMedia.XXS]: {
        width: '60%',
      },

      // [mediaQuery(BreakPoints.Small)]: {
      '@media screen and (max-width: 766px)': {
        '&&': {
          marginTop: Spacings.s32,
          width: '100%',
          order: 2,
        },
      },

      '& img': {
        width: '100%',
        maxWidth: '100%',
        borderRadius: CornerRadius.r20,
      },
    },
    // Skeleton
    skeletonRoot: {
      justifyContent: 'space-between',
      aspectRatio: '2.2',
    },
    smallTitleFB: {
      height: 14,
      marginBottom: Spacings.s8,
    },
    titleFB: {
      height: 84,
      marginBottom: Spacings.s12,

      // [mediaQuery(480)]: {
      '@media screen and (max-width: 480px)': {
        width: '100%',
      },
    },
    descriptionContainerFB: {
      width: 316,
      height: 208,

      [BreakPointsMedia.MD]: {
        width: '25%',
      },
      [BreakPointsMedia.SM]: {
        width: '25%',
      },
      [BreakPointsMedia.XS]: {
        width: '25%',
      },
      [BreakPointsMedia.XXS]: {
        width: '25%',
      },
    },
  },
  {
    name: 'home-banner-block',
  },
);

export default useStyles;
